<div class="carousel">
  <div class="carousel-button-wrapper">
    <carousel-button
      *ngIf="isDesktop"
      class="carousel-button"
      [visible]="carouselService.isShowScrollLeftTopButton"
      [type]="'backward-top'"
      [variant]="'horizontal'"
      (scrollPanel)="carouselService.scrollPanel($event)"
    ></carousel-button>

    <carousel-button
      *ngIf="isDesktop"
      class="carousel-button"
      [visible]="carouselService.isShowScrollRightBottomButton"
      [type]="'forward-bottom'"
      [variant]="'horizontal'"
      (scrollPanel)="carouselService.scrollPanel($event)"
    ></carousel-button>
  </div>

  <tui-scrollbar [hidden]="true" class="content-wrapper">
    <div class="content">
      <ng-content *ngIf="!loading; else loadingTmp"></ng-content>

      <ng-template #loadingTmp>
        <div
          *tuiRepeatTimes="let index of 6"
          class="loading-card"
          [class.tui-skeleton]="true"
          [class.tui-skeleton_rounded]="true"
        ></div>
      </ng-template>
    </div>
  </tui-scrollbar>
</div>
